export default __webpack_public_path__ + "static/media/artwork-card-8.bbd1a04c.png";